<div class="pContainer">
  <div class="pTitle" translate>
  ADD_OPTION_TITLE
  </div>
  <div class="pBody">
    <div class="search">
      <input type="text" class="form-control" autocomplete="off"
             [placeholder]="'FILTER_SEARCH_OPTION' | translate:locale.language"
             [(ngModel)]="query">
    </div>
    <div *ngFor="let item of playerConfigDef$ | async  | FilterByNamePipe:query">
      <storever-add-options-item
      *ngIf="!item.isUsed && item.editionMode === 2"
      (addOptionItem)="addItem($event)"
      [playerConfDef]="item">

      </storever-add-options-item>
   </div>
  </div>

</div>

